"use strict";

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function StaticOrPreviewContent(props) {
  // check for preview=true in query string
  var preview = typeof window !== 'undefined' && (window.location.search || '').indexOf('preview=true') > 0;

  var _a = __read(react_1.useState({
    data: props.staticData,
    requested: false
  }), 2),
      state = _a[0],
      updateState = _a[1];

  if (preview) {
    // if we do not already have live data,
    if (!state.requested) {
      updateState(function (s) {
        return __assign(__assign({}, s), {
          requested: true
        });
      });
      props.getPreviewData().then(function (res) {
        updateState(function (s) {
          return __assign(__assign({}, s), {
            data: res
          });
        });
      });
    }

    return props.render(state.data);
  }

  return props.render(props.staticData);
}

exports.StaticOrPreviewContent = StaticOrPreviewContent;